// extracted by mini-css-extract-plugin
export default {"modalFooter":"mJsTUtihfQ84pPigTjcT","hasBorder":"NDJ2Img9efFfyNxC5XJ4","placeHolderShimmer":"xApyclzm5DSNl22ey8G0"};